import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    name: 'apiKey',
    targetSelector: '.module',
    property: 'data-apikey',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Hero Banner Atom Module
 */
export class GpSmartInstantSearch extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Smart Search & Instant Search';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'smart-search-instant-search';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
